import React, { useState } from 'react';
import styles from './GetHistoryMenu.module.css';
import { getHistoryMenuBd } from '../../firebase';
import LoaderElementSticky from '../LoaderElementSticky/LoaderElementSticky';

export default function GetHistoryMenu({ menuDay }) {
  const [popupHistory, setPopupHistory] = useState({ show: false, historyList: {}, loader: false });

  const getHistoryMenu = async (menuDay) => {
    setPopupHistory({ ...popupHistory, show: true, loader: true });
    const menuHistory = await getHistoryMenuBd('menuHistory', menuDay.menu_history_id);
    setPopupHistory({ historyList: menuHistory, show: true, loader: false });
  };

  const renderHistory = (historyList) => {
    const historyListKeys = Object.keys(historyList);

    if (historyListKeys.length) {
      const historyListSort = historyListKeys.sort((a, b) => historyList[a].id - historyList[b].id);

      return historyListSort.map((historyItem) => {
        return (
          <div key={historyList[historyItem].id} className={styles.history_group_name}>
            {historyList[historyItem].groupName}
          </div>
        );
      });
    }
    return <div>Історію не знайдено:(</div>;
  };

  return (
    <>
      <div className={styles.menu_info_wrapper}>
        <button className={styles.getHistory_btn} onClick={() => getHistoryMenu(menuDay)}>
          Отримати історію цього меню.
        </button>
      </div>
      {popupHistory.show && (
        <div className={styles.popupHistory_wrapper}>
          <div className={styles.popupHistory_content_wrapper}>
            <button
              className={styles.popupHistory_close_btn}
              onClick={() => {
                setPopupHistory({ historyList: {}, show: false, loader: false });
              }}>
              Закрити
            </button>
            <div className={styles.popupHistory_list_wrapper}>
              {popupHistory.loader ? (
                <LoaderElementSticky />
              ) : (
                renderHistory(popupHistory.historyList)
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
